var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCopyPrimary = function SvgIconCopyPrimary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M11.834 9.25v3.5c0 2.917-1.167 4.083-4.084 4.083h-3.5c-2.916 0-4.083-1.166-4.083-4.083v-3.5c0-2.917 1.167-4.083 4.083-4.083h3.5c2.917 0 4.084 1.166 4.084 4.083Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M12.75.167h-3.5c-2.568 0-3.773.911-4.024 3.116-.053.46.329.842.793.842h1.732c3.5 0 5.125 1.625 5.125 5.125v1.732c0 .464.381.846.842.793 2.204-.25 3.116-1.456 3.116-4.025v-3.5c0-2.917-1.167-4.083-4.083-4.083Z"
  })));
};
export default SvgIconCopyPrimary;